export default "__VITE_ASSET__DxGJjJOK__"